exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7b1889a8] .md-menu-content.md-select-menu {\n  width: 150px;\n}\n.modal-container[data-v-7b1889a8] {\n  max-width: 600px;\n}\n.note[data-v-7b1889a8] {\n  font-size: 13px;\n  margin-top: 10px;\n  display: inline-block;\n}\n.option-level-1[data-v-7b1889a8]  .md-list-item-text {\n  font-weight: 500;\n}\n.option-level-2[data-v-7b1889a8] {\n  margin-left: 30px !important;\n}\n", ""]);

// exports
